import axios from 'axios'

console.log(3, process,);
// 解决每次ajax请求，对应的sessionId不一致的问题
//axios.defaults.withCredentials = true;

const service = axios.create({
  baseURL: process.env.VUE_APP_ZNWD_API,
  timeout: 60 * 1000
})
// request interceptor
service.interceptors.request.use(
  config => {
    //let token = store.getters.get_token;
    let token = sessionStorage.getItem("token")

    if (token) {
      config.headers['JWT-AUTHORIZATION'] = token;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      return response.data;
    } else {
      Promise.reject(new Error('错误请求'))
    }
  },
  err => {
    // let response = err.response;
    return Promise.reject(err);
  }
)

export default service
